import styled from 'styled-components';
import { color, spacing } from '../../theme';
import { Heading3 } from '../shared/Typography';

export const StyledJobOfferSubsection = styled.section`
  margin-top: ${spacing('lg')};
`;

export const StyledJobOfferSubsectionTitle = styled(Heading3)`
  && {
    padding-top: ${spacing('xs')};
    margin-bottom: ${spacing('md')};
    text-align: center;
  }
`;
